/**
 * Retrieve a an array of available video sources based on the
 * screens landscape or portrait mode.
 *
 * @param  {HTMLElement} element
 * @return {String[]}
 */
import screenIsPortrait from '../screenIsPortrait';

export default (element) => {
  const landscapeSources = element.getAttribute('data-landscape-poster-src');
  const portraitSources = element.getAttribute('data-portrait-poster-src');

  let sources = landscapeSources;

  if (screenIsPortrait() && portraitSources) {
    sources = portraitSources;
  }

  return sources.split(',').map((source) => source.trim());
};
